import { MosaicWall, TextMosaic, TextMosaicDto } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import { quoteProductType } from '../otherQuoteEntities';

const buttons = [
  { id: quoteProductType.allProducts, label: 'All Products' },
  { id: quoteProductType.inventoryOnly, label: 'Inventory Only' },
];

class ProductTypeSelectionComponent extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    selectedType: PropTypes.number,
  };

  render() {
    const {
      onChange,
      selectedQuoteProductType
    } = this.props;
  
    const options = buttons.map((x) => (
      <TextMosaic
        widthColumns={5}
        key={x.id}
        data={new TextMosaicDto({ ...x, selected: x.id === selectedQuoteProductType })}
        onClick={() => onChange(x.id)}
      />
    ));

    return (
      <div className="row my-4">
        <MosaicWall
          title="Add Product"
          childrenContainerClassName="row justify-content-center"
        >
          {options}
        </MosaicWall>
      </div>
    );
  }
}

export default ProductTypeSelectionComponent;
